import React from 'react';
import { AwardIcon } from 'lucide-react';
import { coachCreditCopy } from '../../data/registration';
export function CoachCreditCard({
  size = 'mobile'
}: {
  size?: 'mobile' | 'desktop';
}) {
  const desktop = size === 'desktop';
  return <section aria-label="Automated Coach Credit" className={`rounded-lg border border-i9-creditLine bg-i9-credit font-i9 ${desktop ? 'px-6 py-5' : 'p-4'}`} data-id="element-252" data-mp="181lne7clelhq">
      <div className="flex items-start gap-3" data-id="element-253" data-mp="1hxeyrneks8xx">
        <span className={`flex shrink-0 items-center justify-center rounded-md bg-i9-steel text-white ${desktop ? 'h-11 w-11' : 'h-9 w-9'}`} aria-hidden="true" data-id="element-254" data-mp="1hw3uznl4r16t">
          <AwardIcon className={desktop ? 'h-6 w-6' : 'h-5 w-5'} data-id="element-255" data-mp="1rqcgvsfnnvw0" />
        </span>
        <div className="min-w-0" data-id="element-256" data-mp="1mportcazlp4f">
          <h2 className={`font-bold leading-snug text-i9-ink ${desktop ? 'text-[19px]' : 'text-[16.5px]'}`} data-id="element-257" data-mp="20oxzfnl4naws">{coachCreditCopy.heading}</h2>
          <p className={`mt-1 leading-relaxed text-i9-muted ${desktop ? 'text-[15px]' : 'text-[14px]'}`} data-id="element-258" data-mp="1vqweex4551io">{coachCreditCopy.body}</p>
          <p className="mt-2 text-[12.5px] font-medium text-i9-infoInk" data-id="element-259" data-mp="1fck0096ec8w9">{coachCreditCopy.footnote}</p>
        </div>
      </div>
    </section>;
}